import { partnersWidget } from '@cred/react-analytics/contexts'
import { logger } from '@cred/fe-logger'

const requiredFields = [
  'source',
  'partnerUrl',
  'partnerReferrer',
  'partnerMeta',
  'widgetGeometry',
  'marketplace',
  'type',
  'variation',
  'credclid',
  'renderId',
]

export const checkIfValidSchema = (analyticsParams) => {
  let isValid = true

  requiredFields.forEach((key) => {
    const analyticsField = analyticsParams[key]

    const isEmpty = analyticsField === undefined || analyticsField === ''

    if (isEmpty) {
      isValid = false

      const error = `required field '${key}' is empty`

      console.error('Snowplow schema error:', error, {
        analyticsParams,
      })

      logger.error(
        'snowplow_schema_error',
        { error, analyticsParams },
        'Error when initializing partners widget context for snowplow analytics',
      )
    }
  })

  return isValid
}

export const getContexts = ({
  source,
  partnerUrl,
  partnerReferrer,
  variation,
  type,
  marketplace,
  size,
  position,
  credclid,
  renderId,
  contentId,
  articleTitle,
  articleTags,
  segmentId,
  campaignCode,
  contentDistributor,
  contentCategory,
  campaignCodeExt,
}) => {
  const analyticsParams = {
    source,
    partnerUrl,
    partnerReferrer,
    widgetGeometry: { position, size },
    marketplace,
    type,
    variation,
    credclid,
    renderId,
    partnerMeta: {
      contentId,
      articleTitle,
      articleTags,
      segmentId,
      campaignCode,
      contentDistributor,
      contentCategory,
      campaignCodeExt,
    },
  }

  const isValidSchema = checkIfValidSchema(analyticsParams)
  const spContexts = [partnersWidget.analytics(analyticsParams)]

  return isValidSchema ? spContexts : null
}
